import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--fill-0, #292A2E)",
      d: "M5.25 12.25c-.963 0-1.75.787-1.75 1.75s.787 1.75 1.75 1.75S7 14.963 7 14s-.787-1.75-1.75-1.75m17.5 0c-.962 0-1.75.787-1.75 1.75s.788 1.75 1.75 1.75 1.75-.787 1.75-1.75-.788-1.75-1.75-1.75m-8.75 0c-.963 0-1.75.787-1.75 1.75s.787 1.75 1.75 1.75 1.75-.787 1.75-1.75-.787-1.75-1.75-1.75"
    }, null, -1)
  ]))]))
}
export default { render: render }